import { Swiper as SwiperType } from "swiper/types";

// A utility function to update the accessibility of slides
export function updateSlidesAccessibility(swiperInstance: SwiperType) {
  const slides = swiperInstance.slides;
  const activeIndex = swiperInstance.activeIndex;

  slides.forEach((slide, index) => {
    const isVisible = index === activeIndex;
    const focusableElements = slide.querySelectorAll<HTMLElement>(
      'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    );

    if (isVisible) {
      // The slide is active
      slide.setAttribute("aria-hidden", "false");
      focusableElements.forEach((el) => el.setAttribute("tabindex", "0"));
      if (focusableElements[0]) {
        focusableElements[0].focus();
      }
    } else {
      // The slide is not active
      slide.setAttribute("aria-hidden", "true");
      focusableElements.forEach((el) => el.setAttribute("tabindex", "-1"));
    }
  });
}
